import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function ObligacionoPravo() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Obligaciono pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Obligaciono pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Obligaciono pravo
              </p>
              <p>
                <strong>Nastavnik:</strong> Đuro Đurić
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 6
              </p>
              <p>
                <strong>Uslov:</strong> Nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Cilj predmeta Obligaciono pravo je upoznavanje studenata sa
                obligacionim pravom kao jednom od najznačajnijih grana u opštem
                sistemu pozitivnog prava, kao i sa pojmom, vrstama i izvorima
                obligacionih odnosa koji se regulišu normama obligacionog prava.
                Cilj predmeta je i da studenti što bolje izuče posebne vrste
                građanskopravnih odnosa između određenih lica koja su jedno
                drugom obavezna na određeno ponašanje (prava i obaveze koje
                proizilaze iz odnosa poverioca i dužnika). Takođe, cilj je i
                povezivanje stečenih znanja u cilju osposobljavanja za primenu
                znanja u praksi.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Nakon uspješno svladanog predmeta Obligaciono pravo studenti će
                biti u mogućnosti da definišu i analiziraju osnovna načela
                obligacionog prava, izvore obligacija, osnovne institute
                obligacionog prava, kao i da uoče sličnosti i razlike rješenja
                domaćeg pozitivnog prava sa rješenjima u uporednom pravu.
                Takođe, studenti će biti u mogućnosti da definišu i analiziraju
                osnovna načela obligacionog prava, izvore obligacija (ugovor,
                prouzrokovanje štete drugome, neosnovano obogaćenje, nezvano
                vršenje tuđih poslova, jednostrane izjave volje). Isto tako, da
                definišu i objasne pravne karakteristike obligacija, uslove
                nastanka, dejstvo, načine i uslove prestanka, obezbeđenje i
                izmene obligacionopravnog odnosa. Takođe, nakon savladanog
                predmeta studenti će biti u mogućnosti da sačine osnovne vrste
                obligacionih ugovora te da analizom teksta različitih ugovora
                identifikuju i objasne osnovne elemente sadržine pomenutih
                ugovora.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                <strong>Teorijska nastava:</strong>
              </p>
              <ul className="values-section">
                <li>
                  Definisanje pojma obligacija, obligacioni odnos, razlike
                  između obligacija i obligacionog odnosa, sadržina obligacionog
                  odnosa, pojam i značaj obligacionog prava, nastanak i razvoj
                  obligacionog prava
                </li>
                <li>
                  Izvori obligacionih odnosa: ugovor, prouzrokovanje štete
                  drugome, neosnovano obogaćenje, vršenje poslova bez naloga,
                  ostali izvori, subjekti obligacionog odnosa
                </li>
                <li>
                  Zaštita obligacionog odnosa, odnos obligacionih i stvarnih
                  prava, vrste obaveza s obzirom na stepen određenosti,
                  obligacioni ugovor, principi slobode ugovaranja, poslovna
                  sposobnost ugovorenika, forma i tumačenje ugovora, vrste
                  obligacionih ugovora
                </li>
                <li>
                  Prestanak ugovora: raskidanje ugovora, poništavanje ugovora,
                  protok vremena i otkaz, smrt jedne strane, gašenje
                  obligacionog odnosa, ispunjenje, prebijanje, oproštaj duga,
                  prenov, sjedinjenje
                </li>
              </ul>
              <p>
                <strong>Praktična nastava:</strong>
              </p>
              <ul className="values-section">
                <li>Analiza sudske prakse</li>
                <li>Debate</li>
                <li>Pisanje ugovora</li>
                <li>Razvijanje tehnika za zaključivanje ugovora</li>
                <li>
                  Analiza svakodnevnih situacija i pronalaženje modaliteta
                  njihovog rješavanja
                </li>
              </ul>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: predavanja, vježbe,
                konsultacije, pismene provjere znanja (kolokvijumi),
                individualni rad studenata (seminarski i domaći radovi, referati
                i sl.) kao i grupno učestvovanje studenata na savladavanju
                određenih tematskih jedinica.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P+2V</td>
                    <td>
                      Pojam i značaj obligacionog prava, nastanak i razvoj
                      obligacionog prava
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P+2V</td>
                    <td>
                      Izvori obligacionog prava, Zakon o obligacionim odnosima
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P+2V</td>
                    <td>
                      Izvori obligacionih odnosa: ugovor, prouzrokovanje štete
                      drugome, neosnovano obogaćenje, vršenje poslova bez
                      naloga, ostali izvori
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P+2V</td>
                    <td>Pojam ugovora i princip slobode ugovaranja</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P+2V</td>
                    <td>
                      Opšti uslovi nastanka ugovora, poslovana sposobnost
                      ugovorenika, pojam i predmet ugovora, praktična nastava,
                      analiza sudske prakse, debate
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>3P+2V</td>
                    <td>
                      Saglasnost volja, zaključivanje obligacionih ugovora,
                      posebni načini sklapanja ugovora, obligacioni odnosi na
                      temelju pregovora
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P+2V</td>
                    <td>Forma i tumačenje ugovora</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P+2V</td>
                    <td>
                      Vrste obligacionih ugovora, ugovor u korist trećeg lica
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P+2V</td>
                    <td>
                      Opšta dejstva ugovora, praktična nastava, pisanje ugovora,
                      razvijanje tehnika za zaključivanje ugovora
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>3P+2V</td>
                    <td>Svojevrsna dejstva uzajamnih ugovora</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P+2V</td>
                    <td>
                      Prestanak ugovora: raskidanje ugovora, poništavanje
                      ugovora, protok vremena i otkaz, smrt jedne strane,
                      praktična nastava, analiza sudske prakse, analiza
                      svakodnevnih situacija i pronalaženje modaliteta njihovog
                      rješavanja
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P+2V</td>
                    <td>Dejstvo obligacionog odnosa</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P+2V</td>
                    <td>
                      Gašenje obligacionog odnosa: ispunjenje, prebijanje,
                      oproštaj duga, prenov, sjedinjenje
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vežbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 5 č / 3.45 h</td>
                            <td>Ukupno: 90 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3 č / 2.15 h</td>
                            <td>Nastava + završni ispit: 65 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 1.3 h</td>
                            <td>Priprema i ovjera semestra: 10 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ObligacionoPravo;
